window.baseURL = process.env.VUE_APP_API_URL || 'https://b2b.mtn.bj/backend/api/v1';
//window.baseURL = process.env.VUE_APP_API_URL || 'http://10.77.152.62:8080/backend/api/v1';

import axios from 'axios'

axios.defaults.baseURL = window.baseURL;

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access');
axios.defaults.headers.post['Content-Type'] = 'application/form-data';
axios.defaults.timeout = 60000;
export default axios.create({});
